function useCampaignDuration() {
  const dateFormat = (timestamp) => {
    const date = new Date(timestamp);
    const day = date.toLocaleDateString("de-DE", { day: "2-digit" });
    const month = date.toLocaleDateString("de-DE", { month: "short" });

    return `${day}. ${month}.`;
  };

  return { dateFormat };
}

export default useCampaignDuration;
